import constants from "../../core/constants";
import moment from "moment";

class Duration {
  constructor() {
    return this.transform.bind(this);
  }

  transform(date) {
    const now = moment();

    const days = now.diff(date, "days");
    const hours = now.diff(date, "hours");
    const minutes = now.diff(date, "minutes");

    return days > 0
      ? moment(date).format(constants.dateTimeFormat)
      : hours > 0
      ? this.getHours(hours)
      : this.getMinutes(minutes);
  }

  getMinutes(minutes) {
    return `${minutes} mins ago`;
  }
  getHours(hours) {
    return `${hours} hours ago`;
  }
}

const durationFnc = () => new Duration();

export default durationFnc;



// WEBPACK FOOTER //
// ./src/filters/duration/duration.filter.js